/**
 * Created by pierremarsot on 25/03/2017.
 */
const rootRoute = {
    path: '/',

    getChildRoutes(partialNextState, callback) {
        require.ensure([], function (require) {
            callback(null, [
                require('./utilisateurs/index').default,
                require('./balises/index').default,
            ]);
        })
    },

    getIndexRoute(partialNextState, callback) {
        require.ensure([], function (require) {
            callback(null, {
                component: require('../pages/login/Login').default,
            });
        })
    },

    getComponents(nextState, callback) {
        require.ensure([], function (require) {
            callback(null, require('../containers/layout/App').default);
        })
    }
};

export default rootRoute;


// WEBPACK FOOTER //
// ./src/routes/index.js